<template>
  <div class="resources-all">
    <Header />
    <div class="rc-content">
      <Categories :categories-info="categories" />
      <div class="most-popular container slider">
        <Slider :disabled="popular.list.length <= 3" dark class-name="resources">
          <h2 slot="heading" class="h3">
            Most Popular Resources
          </h2>
          <p slot="description" class="caption description">
            Check out our most helpful downloadable resources according to 365 Data Science students and our expert team of instructors.
          </p>
          <ResourceCard
            v-for="(resource, idx) in popular.list"
            :key="idx"
            slot="slide"
            :resource="resource"
            no-pin
            class="col col-3 md-4 sm-6"
            :event="`most_popular_${idx + 1}.click`"
            heading="h3"
          />
        </Slider>
      </div>

      <div class="most-popular container order-col">
        <h2 class="h3">
          Most Popular Resources
        </h2>
        <p class="caption description">
          Check out our most helpful downloadable resources according to 365 Data Science students and our expert team of instructors.
        </p>
        <div class="row body">
          <ResourceCard
            v-for="(resource, i) in popular.list"
            :key="i"
            :resource="resource"
            no-pin
            class="col col-3 md-4"
            :event="`most_popular_${i + 1}.click`"
            heading="h3"
          />
        </div>
      </div>

      <PreFooter
        title="Join 2M+ Students and Start Learning"
        description="Learn from the best, develop an invaluable skillset, and secure a job in data science."
        button-title="Start Your Career"
        button-link="/signup/"
        :dark="true"
        class="resources-prefooter"
      />
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import Header from '../../components/Resources/Header';
import Categories from '../../components/Resources/Categories';
import ResourceCard from '../../components/Resources/ResourceCard';
import PreFooter from '../../components/PreFooter';

export default {
  components: {
    Slider,
    Header,
    Categories,
    ResourceCard,
    PreFooter,
  },
  mixins: [global],
  scrollToTop: true,
  async asyncData({ $axios, $config, route }) {
    const { categories, popular } = await $axios.$get('/resources').catch(() => {});

    const page = await $axios.$get(`/pages/${route.fullPath.replace(/\//g, '')}`).catch(() => false) || {};
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;

    return { categories, popular, page };
  },
  head() {
    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      meta: this.metaProps(this.page),
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
    };
  },
};
</script>

<style lang="scss">
.resources-all {
  .rc-content {
    background: var(--main-dark-shade-1);
    padding-top: var(--spacing-120);

    .most-popular {
      padding-bottom: var(--spacing-108);
      padding-top: var(--spacing-80);

      .h3 {
        color: var(--main-light);
        margin: 0;
      }

      .description {
        margin: var(--spacing-16) 0 var(--spacing-36);
        color: var(--main-light-shade-4);
        width: 670px;
        font-size: 18px;
        line-height: 150%;
      }

      .controls {
        svg circle[fill] {
          fill: transparent !important;
        }
      }

      .swiper {
        padding-bottom: var(--spacing-12);
      }

      &.order-col {
        display: none;
      }
    }

    .resources-prefooter .container .row .rc-content {
      background: var(--main-dark);
    }

    .pre-footer {
      padding-top: var(--spacing-120);

      .h2 {
        width: 80%;
        margin: auto;
        margin-bottom: var(--spacing-16);
      }

      .subtitle {
        width: 90%;
        margin: auto;
        color: var(--main-light);
        margin-bottom: var(--spacing-48);
      }

      .bg {
        height: 90px;
        margin-top: 115px;
      }
    }
  }
}

@include bp($bp-laptop) {
  .resources-all .rc-content .most-popular .description {
    width: 565px;
  }
}

@include bp($bp-mobile) {
  .resources-all {
    .rc-content {
      padding-top: var(--spacing-80);

      .most-popular {
        .description {
          width: 100%;
          font-size: 16px;
        }

        &.slider {
          display: none;
        }

        &.container {
          padding-bottom: 180px;
        }

        &.order-col {
          display: block;
        }
      }

      .body .col {
        margin-bottom: var(--spacing-30);

        &:last-child {
          margin-bottom: 0;
        }
      }

      .pre-footer {
        padding-top: var(--spacing-80);

        .h2 {
          width: 100%;
          font-size: var(--spacing-26);
        }

        .subtitle {
          width: 100%;
          line-height: 150%;
        }

        .bg {
          height: 150px;
          margin-top: var(--spacing-80);
        }
      }
    }
  }
}
</style>
